import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import appointmentAPI from '../../sources/api/appointmentAPI';

// constants
import { APPOINTMENT_OPEN } from '../../constants/appointmentTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { appointmentSchema } from '../../schemas/Normalizr';

export function* appointmentOpen(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(APPOINTMENT_OPEN, call(appointmentAPI.open, params), appointmentSchema);
  } catch (e) {
    yield put(error(APPOINTMENT_OPEN, e));
  } finally {
    yield put(doneIndicator(APPOINTMENT_OPEN));
  }
}

export function* watchAppointmentOpen() {
  yield takeEvery(APPOINTMENT_OPEN, appointmentOpen);
}

export default function* root() {
  yield all([
    fork(watchAppointmentOpen)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/appointment/appointmentOpen.js